import React, { useState, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../layout";
import AddUser from "./AddUser";
import TextField from "../../Shared/TextField";
import DropDownField from "../../Shared/DropdownField";
import KendoUserGrid from "./KendoUserGrid";
import { USER_FILTERS } from "../../constants/UserFilter";
import { setUserAllFilters } from "../../store/reducers/UserFilterSlice";

const Users = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.userFilter);
  const [Trigger, setTrigger] = useState({
    filter: false,
    addUser: false,
    show: false,
    reRender: false,
  });
  const [userInfo, setUserInfo] = useState({
    firstName: userData.firstName,
    lastName: userData.lastName,
    email: userData.email,
    accountActivated: userData.accountActivated,
    type: userData.type,
    active: userData.active,
  });

  const renderGrid = useMemo(
    () => ({
      reload: Trigger.reRender,
    }),
    [Trigger.reRender]
  );

  const FilterUser = () => {
    setTrigger((prevTrigger) => ({
      ...prevTrigger,
      reRender: !Trigger.reRender,
    }));
    dispatch(
      setUserAllFilters({
        firstName: userInfo.firstName.trim(),
        lastName: userInfo.lastName.trim(),
        email: userInfo.email.trim(),
        accountActivated: userInfo.accountActivated.trim(),
        type: userInfo.type.trim(),
        active: userInfo.active.trim(),
        currentPage: 1,
      })
    );
    HandleUserFilter(false);
  };

  const HandleUserFilter = (check) => {
    setTrigger((prevTrigger) => ({
      ...prevTrigger,
      filter: check,
    }));
  };

  const HandleSetUser = (childInfo) => {
    if (childInfo.reloadGrid === true) {
      setTrigger((prevTrigger) => ({
        ...prevTrigger,
        reRender: !Trigger.reRender,
        addUser: false,
      }));
    } else {
      setTrigger((prevTrigger) => ({
        ...prevTrigger,
        addUser: false,
      }));
    }
  };

  const AddNewUser = () => {
    setTrigger((prevTrigger) => ({
      ...prevTrigger,
      addUser: true,
    }));
  };

  const FieldData = (textField) => {
    setUserInfo((prevData) => ({
      ...prevData,
      [textField.fieldName]: textField.fieldValue,
    }));
  };

  const FieldValue = (fieldName) => {
    let fieldValue;
    fieldValue = userInfo[fieldName] != null ? userInfo[fieldName] : "";
    return fieldValue;
  };

  return (
    <>
      {Trigger.addUser === true && <AddUser ParentCallBack={HandleSetUser} />}
      <MainLayout>
        <div role="tabpanel" className="tab-pane page-content-wrapper">
          <div className="table-panel">
            <div className="row table-panel-header">
              <div className="col-md-9 col-sm-9">
                <h6>Users</h6>
              </div>
              <div className="col-md-3 col-sm-3 flex-center-end">
                <div className="popuop_open mr-2">
                  <span
                    className="popuop_button"
                    role="button"
                    onClick={() => AddNewUser()}
                    style={{
                      cursor: "pointer",
                      textDecoration: "none",
                      color: "#007bff",
                      marginLeft: "10px",
                      marginTop: "5px",
                      padding: "5px",
                      borderRadius: "5px",
                      backgroundColor: "#f8f9fa",
                      border: "1px solid #007bff",
                    }}
                  >
                    Add User
                  </span>
                </div>

                <div className="popuop_open">
                  <span
                    className="popuop_button"
                    role="button"
                    onClick={() => HandleUserFilter(true)}
                    style={{
                      cursor: "pointer",
                      textDecoration: "none",
                      color: "#007bff",
                      marginLeft: "10px",
                      marginTop: "5px",
                      padding: "5px",
                      borderRadius: "5px",
                      backgroundColor: "#f8f9fa",
                      border: "1px solid #007bff",
                    }}
                  >
                    <FontAwesomeIcon icon="filter" size="lg" />
                  </span>
                </div>

                <Modal
                  show={Trigger.filter}
                  onHide={() => HandleUserFilter(false)}
                  backdrop="static"
                  style={{ top: "8%" }}
                >
                  <Modal.Header closeButton>
                    <Modal.Title className="h3 modal-title text-center text-primary w-100">
                      User Filter
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="flex flex-column justify-content-center">
                    <div className="content">
                      <div className="popup__body">
                        <div className="row">
                          <div className="col-md-6 col-sm-6">
                            <TextField
                              id="firstName"
                              length={255}
                              label="First Name"
                              ReceivedTextData={FieldData}
                              value={FieldValue("firstName")}
                              required={false}
                            />
                          </div>
                          <div className="col-md-6 col-sm-6">
                            <TextField
                              id="lastName"
                              length={255}
                              label="Last Name"
                              ReceivedTextData={FieldData}
                              value={FieldValue("lastName")}
                              required={false}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 col-sm-6">
                            <TextField
                              id="email"
                              length={255}
                              label="Email"
                              ReceivedTextData={FieldData}
                              value={FieldValue("email")}
                              required={false}
                            />
                          </div>
                          <div className="col-md-6 col-sm-6">
                            <DropDownField
                              id="active"
                              label="Active"
                              classDiv
                              required={false}
                              options={USER_FILTERS.ACTIVE_OPTIONS}
                              value={FieldValue("active")}
                              ReceivedTextData={FieldData}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 col-sm-6">
                            <DropDownField
                              id="type"
                              label="Type"
                              classDiv
                              required={false}
                              options={USER_FILTERS.USER_TYPE_OPTIONS}
                              value={FieldValue("type")}
                              ReceivedTextData={FieldData}
                            />
                          </div>
                          <div className="col-md-6 col-sm-6">
                            <DropDownField
                              id="accountActivated"
                              label="Account Activated"
                              classDiv
                              required={false}
                              options={USER_FILTERS.ACTIVE_OPTIONS}
                              value={FieldValue("accountActivated")}
                              ReceivedTextData={FieldData}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row text-center mt-4">
                      <div className="col-md-12 col-sm-12">
                        <label>&nbsp;</label>
                        <input
                          type="button"
                          className="btnLinkBlue"
                          value="Search"
                          onClick={() => FilterUser()}
                        />
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              </div>
            </div>
            <div className="table-panel-body" id="gridWidth">
              <KendoUserGrid renderGrid={renderGrid} />
            </div>
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export default Users;
